// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fa;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.sidebar {
  min-height: 100vh;
  background-color: #343a40;
}

.sidebar .nav-link {
  color: #adb5bd;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  margin: 0.25rem 0;
}

.sidebar .nav-link:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.sidebar .nav-link.active {
  color: #fff;
  background-color: #0d6efd;
}

.main-content {
  padding: 2rem;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.table-responsive {
  border-radius: 0.375rem;
}

.status-pendiente {
  color: #ffc107;
  font-weight: bold;
}

.status-validado {
  color: #198754;
  font-weight: bold;
}

.status-rechazado {
  color: #dc3545;
  font-weight: bold;
}

.login-container {
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.login-container > .container {
  display: flex;
  justify-content: center;
}

.login-card {
  max-width: 400px;
  width: 100%;
  padding: 2rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.filter-section {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.image-preview {
  max-width: 200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 0.375rem;
}

/* Sidebar drawer mobile */
.sidebar {
  min-height: 100vh;
  background-color: #343a40;
  z-index: 1200;
}

@media (max-width: 767.98px) {
  .sidebar {
    position: fixed !important;
    left: -100vw;
    top: 0;
    width: 80vw;
    max-width: 300px;
    height: 100vh;
    transition: left 0.3s cubic-bezier(.4,0,.2,1);
    box-shadow: none;
    padding-top: 1.5rem;
  }
  .sidebar.sidebar-mobile-open {
    left: 0 !important;
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }
  .sidebar-toggle-btn {
    display: flex !important;
  }
  .main-content {
    padding: 1rem;
  }
}

@media (min-width: 768px) {
  .main-content {
    margin-left: 300px;
    padding: 2rem;
  }
  .sidebar {
    width: 300px;
    min-width: 300px;
    max-width: 300px;
    position: fixed !important;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1200;
  }
}

@media (max-width: 767.98px) {
  .main-content {
    margin-left: 0;
    padding: 1rem;
  }
  .sidebar {
    width: 80vw;
    min-width: unset;
    max-width: 300px;
    position: fixed !important;
    left: -100vw;
    top: 0;
    height: 100vh;
    z-index: 1200;
  }
}

/* Estilos para filas seleccionadas - más específicos */
tr.row-selected {
  background-color: rgba(13, 110, 253, 0.15) !important;
  border-left: 4px solid #0d6efd !important;
  box-shadow: inset 0 0 0 2px #0d6efd !important;
}

tr.row-selected:hover {
  background-color: rgba(13, 110, 253, 0.2) !important;
}

/* Mantener el fondo rojo para gastos no validados */
tr.table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

/* Combinación de no validado + seleccionado */
tr.table-danger.row-selected {
  background-color: rgba(13, 110, 253, 0.15) !important;
  border-left: 4px solid #0d6efd !important;
  box-shadow: inset 0 0 0 2px #0d6efd !important;
}

/* Estilos para cards de gastos en móvil */
.gastos-cards {
  padding: 0.5rem 0;
}

.gasto-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #dee2e6;
}

.gasto-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.gasto-card.row-selected {
  background-color: rgba(13, 110, 253, 0.1) !important;
  border-color: #0d6efd !important;
  border-left: 4px solid #0d6efd !important;
}

.gasto-card.table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
  border-color: #dc3545 !important;
}

.gasto-card.table-danger.row-selected {
  background-color: rgba(13, 110, 253, 0.15) !important;
  border-color: #0d6efd !important;
  border-left: 4px solid #0d6efd !important;
}

/* Mejorar la experiencia táctil en móvil */
@media (max-width: 767.98px) {
  .gasto-card {
    margin-bottom: 1rem;
    border-radius: 0.5rem;
  }
  
  .gasto-card .card-body {
    padding: 1rem;
  }
  
  .gasto-card h6 {
    font-size: 1rem;
    font-weight: 600;
  }
  
  .gasto-card .btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
  }
  
  /* Hacer los botones más grandes para touch */
  .gasto-card .btn-sm {
    padding: 0.5rem 0.75rem;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Mejorar espaciado en móvil */
  .main-content {
    padding: 1rem;
  }
  
  .filter-section {
    padding: 1rem;
  }
  
  /* Hacer los checkboxes más grandes en móvil */
  .form-check-input {
    width: 1.25rem;
    height: 1.25rem;
  }
}

/* Animación suave para las transiciones */
.gasto-card,
.row-selected {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
} 

@media (max-width: 767.98px) {
  .card-header .col-12 {
    padding-left: 0;
    padding-right: 0;
  }
  .card-header .btn {
    width: 100%;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }
  .card-header .btn:last-child {
    margin-bottom: 0;
  }
  .card-header {
    flex-direction: column !important;
    align-items: stretch !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,UAAU;EACV,SAAS;EACT,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,OAAO;IACP,MAAM;IACN,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,MAAM;IACN,aAAa;IACb,aAAa;EACf;AACF;;AAEA,uDAAuD;AACvD;EACE,qDAAqD;EACrD,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,oDAAoD;AACpD;EACE,mDAAmD;AACrD;;AAEA,8CAA8C;AAC9C;EACE,qDAAqD;EACrD,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,2CAA2C;AAC3C;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,6CAA6C;EAC7C;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,8CAA8C;EAC9C;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,0CAA0C;AAC1C;;EAEE,iDAAiD;AACnD;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iCAAiC;IACjC,+BAA+B;EACjC;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n.sidebar {\r\n  min-height: 100vh;\r\n  background-color: #343a40;\r\n}\r\n\r\n.sidebar .nav-link {\r\n  color: #adb5bd;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 0.375rem;\r\n  margin: 0.25rem 0;\r\n}\r\n\r\n.sidebar .nav-link:hover {\r\n  color: #fff;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.sidebar .nav-link.active {\r\n  color: #fff;\r\n  background-color: #0d6efd;\r\n}\r\n\r\n.main-content {\r\n  padding: 2rem;\r\n}\r\n\r\n.card {\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\r\n  border: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.table-responsive {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.status-pendiente {\r\n  color: #ffc107;\r\n  font-weight: bold;\r\n}\r\n\r\n.status-validado {\r\n  color: #198754;\r\n  font-weight: bold;\r\n}\r\n\r\n.status-rechazado {\r\n  color: #dc3545;\r\n  font-weight: bold;\r\n}\r\n\r\n.login-container {\r\n  min-height: 100vh;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  padding: 0;\r\n  margin: 0;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.login-container > .container {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.login-card {\r\n  max-width: 400px;\r\n  width: 100%;\r\n  padding: 2rem;\r\n  background: white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.filter-section {\r\n  background-color: #fff;\r\n  padding: 1.5rem;\r\n  border-radius: 0.375rem;\r\n  margin-bottom: 1.5rem;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\r\n}\r\n\r\n.image-preview {\r\n  max-width: 200px;\r\n  max-height: 200px;\r\n  object-fit: cover;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n/* Sidebar drawer mobile */\r\n.sidebar {\r\n  min-height: 100vh;\r\n  background-color: #343a40;\r\n  z-index: 1200;\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .sidebar {\r\n    position: fixed !important;\r\n    left: -100vw;\r\n    top: 0;\r\n    width: 80vw;\r\n    max-width: 300px;\r\n    height: 100vh;\r\n    transition: left 0.3s cubic-bezier(.4,0,.2,1);\r\n    box-shadow: none;\r\n    padding-top: 1.5rem;\r\n  }\r\n  .sidebar.sidebar-mobile-open {\r\n    left: 0 !important;\r\n    box-shadow: 2px 0 8px rgba(0,0,0,0.15);\r\n  }\r\n  .sidebar-toggle-btn {\r\n    display: flex !important;\r\n  }\r\n  .main-content {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .main-content {\r\n    margin-left: 300px;\r\n    padding: 2rem;\r\n  }\r\n  .sidebar {\r\n    width: 300px;\r\n    min-width: 300px;\r\n    max-width: 300px;\r\n    position: fixed !important;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100vh;\r\n    z-index: 1200;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .main-content {\r\n    margin-left: 0;\r\n    padding: 1rem;\r\n  }\r\n  .sidebar {\r\n    width: 80vw;\r\n    min-width: unset;\r\n    max-width: 300px;\r\n    position: fixed !important;\r\n    left: -100vw;\r\n    top: 0;\r\n    height: 100vh;\r\n    z-index: 1200;\r\n  }\r\n}\r\n\r\n/* Estilos para filas seleccionadas - más específicos */\r\ntr.row-selected {\r\n  background-color: rgba(13, 110, 253, 0.15) !important;\r\n  border-left: 4px solid #0d6efd !important;\r\n  box-shadow: inset 0 0 0 2px #0d6efd !important;\r\n}\r\n\r\ntr.row-selected:hover {\r\n  background-color: rgba(13, 110, 253, 0.2) !important;\r\n}\r\n\r\n/* Mantener el fondo rojo para gastos no validados */\r\ntr.table-danger {\r\n  background-color: rgba(220, 53, 69, 0.1) !important;\r\n}\r\n\r\n/* Combinación de no validado + seleccionado */\r\ntr.table-danger.row-selected {\r\n  background-color: rgba(13, 110, 253, 0.15) !important;\r\n  border-left: 4px solid #0d6efd !important;\r\n  box-shadow: inset 0 0 0 2px #0d6efd !important;\r\n}\r\n\r\n/* Estilos para cards de gastos en móvil */\r\n.gastos-cards {\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.gasto-card {\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.gasto-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.gasto-card.row-selected {\r\n  background-color: rgba(13, 110, 253, 0.1) !important;\r\n  border-color: #0d6efd !important;\r\n  border-left: 4px solid #0d6efd !important;\r\n}\r\n\r\n.gasto-card.table-danger {\r\n  background-color: rgba(220, 53, 69, 0.1) !important;\r\n  border-color: #dc3545 !important;\r\n}\r\n\r\n.gasto-card.table-danger.row-selected {\r\n  background-color: rgba(13, 110, 253, 0.15) !important;\r\n  border-color: #0d6efd !important;\r\n  border-left: 4px solid #0d6efd !important;\r\n}\r\n\r\n/* Mejorar la experiencia táctil en móvil */\r\n@media (max-width: 767.98px) {\r\n  .gasto-card {\r\n    margin-bottom: 1rem;\r\n    border-radius: 0.5rem;\r\n  }\r\n  \r\n  .gasto-card .card-body {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .gasto-card h6 {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .gasto-card .btn {\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 0.875rem;\r\n  }\r\n  \r\n  /* Hacer los botones más grandes para touch */\r\n  .gasto-card .btn-sm {\r\n    padding: 0.5rem 0.75rem;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  /* Mejorar espaciado en móvil */\r\n  .main-content {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .filter-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  /* Hacer los checkboxes más grandes en móvil */\r\n  .form-check-input {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n  }\r\n}\r\n\r\n/* Animación suave para las transiciones */\r\n.gasto-card,\r\n.row-selected {\r\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n} \r\n\r\n@media (max-width: 767.98px) {\r\n  .card-header .col-12 {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n  .card-header .btn {\r\n    width: 100%;\r\n    margin-bottom: 0.5rem;\r\n    font-size: 1rem;\r\n    padding: 0.75rem 1rem;\r\n  }\r\n  .card-header .btn:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n  .card-header {\r\n    flex-direction: column !important;\r\n    align-items: stretch !important;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
